namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_settings_widget_page, {
		
		// background: {
		// 	color: 'transparent'
		// },
		outlineOffset: '0.5px',
		
		Content_scroll: {
			background: {
				color: $mol_theme.back
			},
		},

		Fullsize_wrapper: {
			background: {
				color: $mol_theme.card
			},
		},

		Page: {
			width: '100%',
		},
		
	} )
	
}
